export function Badge({ label, color }: { label: string; color: string }) {
  return (
    <span className="badge" style={{ color }}>
      {label}
    </span>
  );
}
